import "./follow-brand-store-sign-in.scss";

const $$getModal = () => $(".js-follow-brand-store-sign-in");
const $$getModalClose = () => $(".js-follow-brand-store-sign-in-close");
const $$getModalForm = () => $(".js-follow-brand-store-sign-in-form");
const $$getErrorsContainer = () => $(".js-follow-brand-store-sign-in-error");

export default () => {
  const $$modal = $$getModal();
  const $$modalClose = $$getModalClose();
  const $$modalForm = $$getModalForm();
  const $$errorsContainer = $$getErrorsContainer();

  $$modalForm.on({
    "ajax:before": () => {
      $$errorsContainer.hide();
    },
    "ajax:error": (_event, error) => {
      const errorMessage = JSON.parse(error.responseText).error_message;
      $$errorsContainer.show().text(errorMessage);
    }
  });

  $$modalClose.on("click", () => {
    $$errorsContainer.hide();
    $$modal.modal("hide");
  });
};
